// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox-title[data-v-07c58ea2]{margin-top:40px}.title-2[data-v-07c58ea2]{font-weight:800;font-size:20px;margin-bottom:5px}.title-3[data-v-07c58ea2]{font-weight:600;font-size:13px}.row[data-v-07c58ea2]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;margin-left:0;margin-right:0}.update-button[data-v-07c58ea2]{background-color:#180f29;color:#fff}", ""]);
// Exports
module.exports = exports;
